import React from 'react';
import '../Style/App.css';

const CustomAlert = ({
  isVisible,
  type = 'info',
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'OK',
  cancelText = 'Cancel',
  showCancel = false
}) => {
  const getAlertIcon = () => {
    switch (type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  const getAlertTitle = () => {
    if (title) return title;

    switch (type) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'warning':
        return 'Warning';
      case 'info':
      default:
        return 'Information';
    }
  };

  const handleOverlayClick = (e) => {
    // Close alert if clicking on overlay (not the alert container)
    if (e.target === e.currentTarget) {
      if (onCancel) {
        onCancel();
      } else if (onConfirm) {
        onConfirm();
      }
    }
  };

  // Focus management for accessibility
  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isVisible) return;

      if (e.key === 'Escape') {
        if (onCancel) {
          onCancel();
        } else if (onConfirm) {
          onConfirm();
        }
      } else if (e.key === 'Enter') {
        if (onConfirm) {
          onConfirm();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isVisible, onConfirm, onCancel]);

  if (!isVisible) return null;

  return (
    <div className="alertOverlay" onClick={handleOverlayClick}>
      <div className={`alertContainer alert${type.charAt(0).toUpperCase() + type.slice(1)}`}>
        <div className="alertHeader">
          <span className="alertIcon">{getAlertIcon()}</span>
          <h3 className="alertTitle">{getAlertTitle()}</h3>
        </div>
        
        <div className="alertBody">
          <p className="alertMessage">{message}</p>
        </div>
        
        <div className="alertFooter">
          {showCancel && onCancel && (
            <button 
              className="alertBtn secondary" 
              onClick={onCancel}
              autoFocus={!onConfirm}
            >
              {cancelText}
            </button>
          )}
          {onConfirm && (
            <button 
              className="alertBtn" 
              onClick={onConfirm}
              autoFocus={true}
            >
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomAlert;
